import { type ReactElement, type SVGProps } from 'react';

export const ShareIcon = (props: SVGProps<SVGSVGElement>): ReactElement => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M11.999 2L16.0444 6.01709L15.3398 6.72667L12.5114 3.91803V13.0011H11.5114V3.90052L8.68302 6.72563L7.97632 6.01812L11.999 2Z"
        fill="currentColor"
      />
      <path d="M5.99981 7.00098H4V22.001H20V7.00098H18.0002V8.00098H19V21.001H5V8.00098H5.99981V7.00098Z" fill="currentColor" />
    </svg>
  );
};
